let roles = {
    superadmin: {
        can: ['brokerageprofile.view', 'brokerageprofile.edit', 'emailtemplates.view', 'emailtemplates.edit'],
        inherits: ['admin'],
    },
    admin: {
        can: [],
        inherits: ['tc'],
    },
    tc: {
        can: [
            'dashboard.view',
            'files.view',
            'filedetail.view',
            'agents.view',
            'agentprofile.view',
            'agentprofile.edit',
            'brokerageprofile.view',
            'makelisting.view',
            'maketransaction.view',
            'google.link',
        ],
        inherits: [],
    },
    sales: {
        can: ['sales/agents.view', 'agentprofile.view', 'brokerageprofile.view'],
        inherits: [],
    },
};

export default class PermissionStore {
    constructor(appStore) {
        this.appStore = appStore;
    }

    can(role, operation) {
        //Support passing in a role or using the logged in coordinator
        if (!operation) {
            operation = role;
            role = this.appStore.coordinatorDetailStore.coordinator.role
                ? this.appStore.coordinatorDetailStore.coordinator.role
                : null;
        }

        if (!roles[role]) {
            return false;
        }
        let rolePermissions = roles[role];

        if (rolePermissions.can.includes(operation)) {
            return true;
        }
        if (!rolePermissions.inherits || rolePermissions.inherits.length < 1) {
            return false;
        }
        return rolePermissions.inherits.some((childRole) => this.can(childRole, operation));
    }
}



// WEBPACK FOOTER //
// ./src/app-main/permission-store.js